import http from '../utils/api'

export const getLeadsList = (pagination, filters, sorter, searchTerm) =>
  http.post('/leads', {
    pagination,
    filters,
    sorter,
    searchTerm,
  })
